import { Model } from "miragejs";

export default {
  projectType: Model,
  project: Model,
  target: Model,
  export: Model,
  product: Model,
  rule: Model
}